import React from 'react';
import LocationTemplate from './LocationTemplate';

const BattleboroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Battleboro"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27809"]}
      latitude={36.0382}
      longitude={-77.7478}
      population={1429}
      historicalFact="Named after the Battle of Tarboro Bridge during the Civil War; incorporated in 1893."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Tarboro, NC",
        "Sharpsburg, NC",
        "Nashville, NC",
        "Dortches, NC",
        "Red Oak, NC",
        "Elm City, NC",
        "Wilson, NC"
      ]}
    />
  );
};

export default BattleboroPage;